import { Zap, Compass, Lock } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, ChapterTag } from "./Reveal";

const icons = [Zap, Compass, Lock];

export default function WhyUs() {
  const { t } = useLang();
  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-32 bg-navy-800/40 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <ChapterTag num="05" label={t("ch_why")} />
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight max-w-3xl">{t("why_title")}</h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-8">
          {t("why_features").map((f, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={f.t} delay={i * 0.12}>
                <div data-testid={`why-card-${i}`}
                  className="group glass rounded-2xl p-8 h-full transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-gold/40">
                  <div className="w-14 h-14 rounded-2xl bg-gold/10 border border-gold/25 flex items-center justify-center text-gold mb-6 transition-transform duration-300 group-hover:scale-110">
                    <Icon size={26} />
                  </div>
                  <h3 className="font-display font-bold text-xl md:text-2xl">{f.t}</h3>
                  <p className="mt-3 text-white/55 text-sm md:text-base leading-relaxed">{f.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
